import { createContext } from 'react';

/** 宿主仍拥有返回与操作；页面只接管它们的布局。 */
export const PageHeaderHostContext = createContext({});

/** 只识别显式模式，旧 JSON 与未知值均保留旧布局。 */
export function usesPageHeader(style) {
  return style === 'collapsing' || style === 'fixed' || style === 'custom';
}

/** 从当前页根节点派生导航所有权，避免加载和换页时维护第二份状态。 */
export function pageHeaderStyle(blueprint, pageId) {
  const page = blueprint?.pages?.find((p) => pageId ? p.id === pageId : p.entry)
    || (!pageId ? blueprint?.pages?.[0] : null);
  const root = blueprint?.components?.[page?.root];
  return root?.type === 'PageShell' && usesPageHeader(root.props?.headerStyle) ? root.props.headerStyle : null;
}
